import store from "../store";

export function getPlanName(customer, cAccount) {
	if (!customer) {
		return "no_customer";
	}
	const account = cAccount ? cAccount : store.getState().global.account;

	const sub = customer.subscriptions?.[0];
	const subItem = sub?.items?.[0];
	const price = subItem?.price;

	let key = "no_subscription";

	if (account.partner) {
		key = "partner";
	} else if (customer !== undefined) {
		if (!sub) {
			key = "no_subscription";
		} else if (!price?.metadata?.category) {
			key = "legacy";
		} else if (price?.metadata?.category) {
			key = price?.metadata?.category;
		}
	}

	return key;
}